import { Suspense, lazy, useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  IDia,
  IEjercicioRutina,
  ISemana
} from '../../../Interfaces/IMisRutinas';
import { IUserFromStorage } from '../../../Interfaces/IUser';
import { obtenerRutinaDeEjercicio } from '../../../Services/MisRutinas';
import TitleContainer from '../../../Components/TitleContainer/TitleContainer';

import AlarmIcon from '@mui/icons-material/Alarm';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EjercicioRutinaPorDia from './EjercicioRutinaPorDia/EjercicioRutinaPorDia';
// import ReactPlayer from 'react-player';
// import { ContainerButtonPlay } from '../../../Utils/Button';

const FinalizarRutinaDialog = lazy(() => import('./Dialogs/FinalizarRutinaDialog'));
// const Series = lazy(() => import('./Series/Series'));
// const Reemplazos = lazy(() => import('./Reemplazos/Reemplazos'));
// const ReemplazoEjercicioDialog = lazy(() => import('./Dialogs/ReemplazoEjercicioDialog'));


function RutinasPorDía() {
  // variables
  const [ejercicios, setEjercicios] = useState<IEjercicioRutina[]>();
  const isMobile = useMediaQuery('(max-width: 650px)');
  const diaFromStorage: IDia = JSON.parse(
    localStorage.getItem('currentDiaSelected'),
  );
  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));

  const currentSemanaSelected = JSON.parse(localStorage.getItem('currentSemanaSelected'));
  const [changeRutinas, setChangeRutinas] = useState<boolean>(false);

  const [currentEjerciciofit4RutinaID, setCurrentEjerciciofit4RutinaID] = useState(0);

  // states

  const [isFinalizarRutinaModalOpen, setIsFinalizarRutinaModalOpen] = useState<boolean>(false);
  // const [mostrarVideo, setMostrarVideo] = useState(false);
  

  const descanso = localStorage.getItem('descanso');
  const currentOrdenFinalizado = localStorage.getItem('currentOrdenFinalizado');

  const navigate = useNavigate();

  // functions

  const handlerFinalizarRutina = () => {
    setIsFinalizarRutinaModalOpen(true);
  };

  function obtenerDiaFromLocalStorage() {
    //busco la semana actual en el localstorage
    // const semanas = JSON.parse(localStorage.getItem('semanas'));
    // const semana = semanas?.find(
    //   (semana: ISemana) =>
    //     semana.numeroSemana === currentSemanaSelected.numeroSemana,
    // );
    // voy a buscar el día seleccionado dentro de las semanas que tengo el localstorage, el dia es diaFromStorage
    return diaFromStorage;
  }

  useEffect(() => {
    // voy a buscar el dia seleccionado en el localstorage
    // const dia = obtenerDiaFromLocalStorage();
    // console.log(dia, 'Dia from storage');

    // // ahora verifico el valor de fit4RutinaID
    // const fit4RutinaID = dia?.fit4RutinaID;

    // si el valor de fit4RutinaID es 0, entonces voy a buscar la rutina de ejercicio por primera vez
    if (diaFromStorage.fit4RutinaID === 0) {
      obtenerRutinaEjercicio(diaFromStorage, currentSemanaSelected, 0)
      console.log('Without fit4RutinaID');
    } else {
      // si el valor de fit4RutinaID es diferente de 0, entonces voy a buscar la rutina de ejercicio
      setCurrentEjerciciofit4RutinaID(diaFromStorage.fit4RutinaID);
      obtenerRutinaEjercicio(diaFromStorage, currentSemanaSelected, diaFromStorage.fit4RutinaID);
      console.log('With Fit4rutinaID');
    }
    window.scrollTo(0, 0);
    // obtenerRutinaEjercicio(diaFromStorage, currentSemanaSelected);
  }, []);

  useEffect(() => {
    if (currentEjerciciofit4RutinaID !== 0) {
      obtenerRutinaEjercicio(
        diaFromStorage,
        currentSemanaSelected,
        currentEjerciciofit4RutinaID,
      );
      console.log(currentEjerciciofit4RutinaID, 'Fit4Rutinaid');
    }
  }, [changeRutinas]);

  const obtenerRutinaEjercicio = (
    dia: IDia,
    semana: ISemana,
    id: number,
  ) => {
    if (user) {
      obtenerRutinaDeEjercicio({
        Dia: dia.dia,
        Nivel: semana.nivelString,
        Fit4RutinaID: id,
        NumeroSemana: semana.numeroSemana,
        UsuarioTestAsesoriaID: Number(user.usuarioTestAsesoriaID),
      })
        .then((response) => {
          if (response.data.data) {
            const {ejercicios} = response.data.data;

            setEjercicios(ejercicios);
            // console.log(response.data.data.ejercicios[0].ejercicioItems[0].fit4RutinaID);
            setCurrentEjerciciofit4RutinaID(ejercicios[0].ejercicioItems[0].fit4RutinaID);
            //voy a setear el valor de fit4RutinaID en el día seleccionado
            const dia : IDia = obtenerDiaFromLocalStorage();
            // seteo el valor de fit4RutinaID en el día seleccionado
            dia.fit4RutinaID = ejercicios[0]?.ejercicioItems[0]?.fit4RutinaID;
            // guardo el valor de fit4RutinaID en el localstorage, dentro de las semanas, en el día en el que me encuentro

            const semanas = JSON.parse(localStorage.getItem('semanas'));
            semanas.map((semana: ISemana) => {
              if (semana.numeroSemana === currentSemanaSelected.numeroSemana) {
                semana.dias.map((dia: IDia) => {
                  if (dia.dia === diaFromStorage.dia) {
                    dia.fit4RutinaID = ejercicios[0].ejercicioItems[0].fit4RutinaID;
                  }
                });
              }
            });

            // Convertir el array 'semanas' a una cadena JSON y guardarla en el localStorage
            localStorage.setItem('semanas', JSON.stringify(semanas));

            localStorage.setItem('currentDiaSelected', JSON.stringify(dia));
            // console.log(dia, 'dia');
            // console.log(currentOrdenFinalizado, 'currentOrdenFinalizado');
          }

        })
        .finally(() => {
          navigate('/ejercicioRutina');
        });
    }
  };

  // console.log(ejercicios);

  return (
    <div className="ejrut-page">
      {/* Header */}
      <div className="ejrut-header" style={!isMobile ? { marginTop: '5vh'} : {}}>
        <button
          className="ejrut-back-btn"
          onClick={() => navigate('/misRutinas')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="ejrut-title">
          {currentSemanaSelected.semana} · {diaFromStorage.diaString}
        </h1>
      </div>

      <div className="ejrut-content">
        {/* Rest Time */}
        <div className="ejrut-rest-card">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
          </svg>
          <p className="ejrut-rest-text">{descanso}</p>
        </div>

        {/* Finalizar Button (top) */}
        {diaFromStorage.estado !== '2' &&
          diaFromStorage.orden === Number(currentOrdenFinalizado) && (
            <button
              className="ejrut-finalizar-btn"
              onClick={handlerFinalizarRutina}
            >
              <CheckCircleIcon sx={{ fontSize: 20 }} /> Finalizar Rutina
            </button>
          )}

        {/* Exercises */}
        {ejercicios &&
          ejercicios.map((ejercicio: IEjercicioRutina, index: number) => (
            <div className="ejrut-exercise" key={index}>
              <EjercicioRutinaPorDia
                orden={index + 1}
                ejercicioProp={ejercicio}
                diaFromStorage={diaFromStorage}
                changeRutinas={changeRutinas}
                setChangeRutinas={setChangeRutinas}
              />
            </div>
          ))}

        {/* Finalizar Button (bottom) */}
        {diaFromStorage.estado !== '2' &&
          diaFromStorage.orden === Number(currentOrdenFinalizado) && (
            <button
              className="ejrut-finalizar-btn"
              onClick={handlerFinalizarRutina}
              style={{ marginTop: '1rem' }}
            >
              <CheckCircleIcon sx={{ fontSize: 20 }} /> Finalizar Rutina
            </button>
          )}
      </div>

      <Suspense fallback={<div />}>
        {isFinalizarRutinaModalOpen && (
          <FinalizarRutinaDialog
            isOpen={isFinalizarRutinaModalOpen}
            setIsOpen={setIsFinalizarRutinaModalOpen}
            rutinaID={currentEjerciciofit4RutinaID}
          />
        )}
      </Suspense>
    </div>
  );
}

export default RutinasPorDía;
